/**
 * What the planner calls things.
 *
 * TravPlaces plans government field operations — an inspection round, a
 * welfare visit, a patrol between sites — and the engine underneath has
 * always been "visit these kinds of place, in this much time, keeping clear
 * of those". Only the words were written for a day out.
 *
 * This is a DISPLAY layer and nothing more. Route styles and themes keep the
 * labels they carry in the database, because those are edited in Admin,
 * referenced by saved routes and returned by the API; renaming a row to
 * change a caption would rewrite somebody's data to fix a word. So the
 * operational name is looked up by key here, and anything without one falls
 * back to what the database says.
 */

/*
 * Route styles are named in Admin too, and were not.
 *
 * Two maps lived here, rewriting a style's name and description on the way to
 * the screen: the planner said "Outlying Areas Patrol" while the row it came
 * from said "Off the Grid Wander", and Admin showed the row. Renaming a style
 * there changed nothing a traveller saw.
 *
 * The operational wording was not thrown away — 000031_operational_style_names
 * moved it into the database, which is where Admin edits it. So the words on
 * screen are the same words; there is simply one copy of them now.
 */

/*
 * Emphases are named in Admin, and nowhere else.
 *
 * Three of them used to be renamed here on the way to the screen: `culture`
 * read as "Civic sites first" in the planner and "Culture-led" on the page
 * that edits it, and the two screens never said they meant the same emphasis.
 * An operator looking for "Provisioning stops" in the theme list did not find
 * it, because there it is called "Food-led".
 *
 * A name somebody can edit and a name the code overrides cannot both be the
 * name. The label in Admin wins: change it there and every screen follows,
 * which is what an editable label is for.
 */

/**
 * What to call a route style, and how to describe it: whatever Admin says.
 *
 * Kept as functions rather than reading `.label` and `.description` at each
 * call site, so the one place that decides this stays one place.
 */
export const styleName = (_key: string, label: string) => label;

export const styleDescription = (_key: string, description: string) => description;

/**
 * What to call an emphasis: whatever Admin calls it.
 *
 * Kept as a function rather than reading `.label` at each of its twelve call
 * sites, so the one place that decides this stays one place.
 */
export const themeName = (_key: string, label: string) => label;
